module.exports = __webpack_public_path__ + "static/Private Lessons-777d9aa55e809b4be6b961eb75b51c87.pdf";